import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output, ViewChild, WritableSignal, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { DialogData } from '../get-time/get-time.component';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';
import { InputTextComponent } from '../../inputs/input-text/input-text.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DialogComponent } from 'src/app/layout/dialogs/dialog/dialog.component';
import { TextFieldComponent } from '../../fields/text-field/text-field.component';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { MyButtonComponent } from '../../buttons/my-button/my-button.component';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-get-maps-edit',
  standalone: true,
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatRippleModule,
    DialogComponent,
    GoogleMap,
    MapAdvancedMarker,
    InputTextComponent,
    TextFieldComponent,
    MyButtonComponent
  ],
  templateUrl: './get-maps-edit.component.html',
  styleUrl: './get-maps-edit.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetMapsEditComponent {
  @ViewChild('myMap') map!: GoogleMap;

  center: WritableSignal<google.maps.LatLngLiteral> = signal({ lat: 41.8992, lng: 12.5450 });
  zoom: WritableSignal<number> = signal(18);
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    tilt: 0,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,
  };
  markerPosition: WritableSignal<google.maps.LatLngAltitudeLiteral | null> = signal(null);
  form: FormGroup;
  addressSearchResults: WritableSignal<google.maps.places.PlaceResult[]> = signal([]);
  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @Output() modelChange = new EventEmitter<any | undefined>();
  @Input() reload?: EventEmitter<any>;
  
  constructor(
    public dialogRef: MatDialogRef<GetMapsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData | any,
    private readonly fb: FormBuilder,
  ) {
    // this.data = { ...TIME_SETTINGS, ...this.data };
    this.form = this.fb.group({
      search: new FormControl(''),
    });
    this.getMyLocation();
    this.initializeSearch()
    //necessari per l'edit del punti di campionamento
    if(this.data && this.data.coordinate){
        this.setMarker(this.data.coordinate?.lat, this.data.coordinate?.lng,this.data.coordinate?.altitude)
      }

 
  }
  ngOnInit(){
    this.center().lat=this.data.formSave.get("coordinateMaps").value.lat
    this.center().lng=this.data.formSave.get("coordinateMaps").value.lng
  }
  onSelectClick() {
    this.dialogRef.close(this.markerPosition());
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  initializeSearch() {
    this.form.get('search')?.valueChanges
      .pipe(
        debounceTime(500), // Aggiungi un ritardo prima di applicare il filtro
        distinctUntilChanged() // Filtra solo se il valore cambia rispetto al precedente
      )
      .subscribe((value: string) => {
        const location = this.getAddress(value);
        if (location) {
          this.center.set({
            lat: location.geometry?.location?.lat() ?? 0,
            lng: location.geometry?.location?.lng() ?? 0,
          });
          this.zoom.set(18);
        } else {
          this.search(value);
        }
      });
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.setMarker(event.latLng?.lat()!, event.latLng?.lng()!);
    }
  }

  async getAltitude(latitude: number, longitude: number): Promise<number | undefined> {
    const elevator = new google.maps.ElevationService();
    let altitude: number | undefined = undefined;
    await elevator.getElevationForLocations({
      locations: [{ lat: latitude, lng: longitude }]
    }).then(({ results }) => {
      if (results?.length > 0) {
        altitude = results[0].elevation;
      }
    });
    return altitude;
  }

  async setMarker(latitude: number, longitude: number, altitude?: number) {
    this.markerPosition.set({
      lat: latitude,
      lng: longitude,
      altitude: altitude ?? await this.getAltitude(latitude, longitude) ?? 0
    });
  }

  setMarkerToMapCenter() {
    const center = this.getMapCenter();
    if (center) {
      this.setMarker(center.lat(), center.lng())
    }
  }

  removeMarker() {
    this.markerPosition.set(null);
  }

  getMapCenter() {
    return this.map.getCenter();
  }

  getMyLocation() {
    this.form.get('search')?.reset();
    navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
      this.center.set({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      })
      this.zoom.set(18);
    });
  }

  async search(keyword: string) {
    this.addressSearchResults.set([]);
    if (keyword && keyword !== '') {
      var request = {
        query: keyword,
      };
      const PlacesLibrary: google.maps.PlacesLibrary = await google.maps.importLibrary("places") as google.maps.PlacesLibrary
      const service = new PlacesLibrary.PlacesService(this.map.googleMap!);
      service.textSearch(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && results !== null) {
          this.addressSearchResults.set(results)
        }
      });
    }
  }

  getAddress(formattedAddress: string) {
    return this.addressSearchResults().find((location) => location.formatted_address === formattedAddress);
  }
  onSaveClick() {
 
   this.data.formSave.get("coordinateMaps").value.lat=this.markerPosition()?.lat
   this.data.formSave.get("coordinateMaps").value.lng=this.markerPosition()?.lng
   this.data.formSave.get("coordinateMaps").value.altitude=this.markerPosition()?.altitude
    if (this.data.formSave?.valid) {
    
      this.data.crud?.save(this.data.formSave?.value, this.data.modelId).subscribe((modelValue:any) => {
      
        this.data.model = modelValue;
        this.modelChange.emit(this.data.model);
        this.save.emit(modelValue);
        if (this.reload) {
          this.reload.emit();
        }
        this.dialogRef.close(this.data.model)
      });
    }
  }
}
